import { VIEW_MODE } from '@/common/define/common.define';
import { ValueOf } from '@/types/common.types';
import { LicenseType } from './license.type';

export const LicenseTypeName = [
  'application',
  'cloud',
  'container',
  'database',
  'infrastructure',
] as const;

export const LicenseLevel = [
  'PERM',
  'TERM',
  'PERM (Flexible)',
  'TERM (Flexible)',
  'TRIAL',
  'NONE',
] as const;
export const LicenseTypeFilters = [...LicenseLevel];

export const LicenseTargetDisplayName = {
  ndm: 'NDM',
  kafka: 'Kafka',
  apm: 'APM',
  redis: 'Redis',
  postgresql: 'PostgreSQL',
  mysql: 'MySQL',
  oracle: 'Oracle',
  sqlServer: 'SQL Server',
  aws: 'AWS',
  azure: 'Azure',
  gcp: 'GCP',
  ncp: 'NCP',
} as const;

export const LicenseTargetLanguageKeys = {
  host: 'HOST',
  log: 'LOG',
  container: 'CONTAINER',
  appContainer: 'APPLICATION_CONTAINER',
  allDimension: 'TOTAL_DIMENSION',
};

export const LicenseTargetUnitLanguageKeys = {
  host: 'HOST',
  log: 'LOGS',
  vcore: 'VCORE',
  instance: 'INSTANCE',
  device: 'NETWORK_DEVICE',
};

export const LicenseTypeByViewMode: Partial<Record<ValueOf<typeof VIEW_MODE>, LicenseType[]>> = {
  exemone: ['infrastructure', 'container', 'database', 'application', 'cloud'] as const,
  maxgauge: ['infrastructure', 'database', 'cloud'] as const,
  intermax: ['infrastructure', 'container', 'application'] as const,
  cloudmoa: ['infrastructure', 'container', 'application', 'database', 'cloud'] as const,
};
